import { useEffect, useRef } from "react";

const COLORS = ["#f59e0b", "#ea580c", "#fbbf24", "#fdba74"];

export const ClickSparks = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        const ctx = canvas.getContext("2d");
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        let raf = null;
        let sparks = [];

        const resize = () => {
            canvas.width = window.innerWidth * dpr;
            canvas.height = window.innerHeight * dpr;
            canvas.style.width = `${window.innerWidth}px`;
            canvas.style.height = `${window.innerHeight}px`;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };

        const tick = () => {
            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
            sparks = sparks.filter((s) => s.life > 0);
            for (const s of sparks) {
                s.x += s.vx;
                s.y += s.vy;
                s.vy += 0.12;
                s.vx *= 0.985;
                s.life -= 0.02;
                ctx.beginPath();
                ctx.arc(s.x, s.y, s.size * Math.max(0.2, s.life), 0, Math.PI * 2);
                ctx.fillStyle = s.color;
                ctx.globalAlpha = Math.max(0, s.life);
                ctx.shadowColor = s.color;
                ctx.shadowBlur = 10;
                ctx.fill();
            }
            ctx.globalAlpha = 1;
            ctx.shadowBlur = 0;
            if (sparks.length > 0) {
                raf = requestAnimationFrame(tick);
            } else {
                raf = null;
                ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
            }
        };

        const onClick = (e) => {
            const target = e.target.closest(
                'a[href*="wa.me"], [data-testid="form-submit-button"]'
            );
            if (!target) return;
            for (let i = 0; i < 16; i++) {
                const angle = Math.random() * Math.PI * 2;
                const speed = 1.5 + Math.random() * 3.5;
                sparks.push({
                    x: e.clientX,
                    y: e.clientY,
                    vx: Math.cos(angle) * speed,
                    vy: Math.sin(angle) * speed - 1.5,
                    size: 1.5 + Math.random() * 2.5,
                    life: 0.7 + Math.random() * 0.5,
                    color: COLORS[(Math.random() * COLORS.length) | 0],
                });
            }
            if (!raf) raf = requestAnimationFrame(tick);
        };

        resize();
        window.addEventListener("resize", resize);
        window.addEventListener("click", onClick, { passive: true });
        return () => {
            if (raf) cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
            window.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            aria-hidden="true"
            data-testid="click-sparks-canvas"
            className="pointer-events-none fixed inset-0 z-[70]"
        />
    );
};
